/**
 * 多个页面会使用的公共接口
 */
import { get, post } from '@/common/request/index';

/**
 * 获取验证
 * https://yapi.lanhanba.com/project/307/interface/api/33536
 */
export function sendCaptcha(params: Record<string, any>) {
  return get('/sendCode', params, true);
}

/**
 * 登录
 * https://yapi.lanhanba.com/project/307/interface/api/33537
 */
export function postLogin(params: Record<string, any>) {
  return post('/login', { ...params }, true);
}

/**
 * 租户列表：https://yapi.lanhanba.com/project/307/interface/api/33539
 */
export function tntList(token) {
  return get('/tntList', {}, {
    headers: {
      token,
    },
    needHint: true
  });
}

/**
 * 城市列表
 * https://yapi.lanhanba.com/project/307/interface/api/33557
 */

export function getCities(params?: any) {
  return get('/requirement/selection/cityList', { ...params }, true);
}

export function getDepartmentCities(params?: any) {
  return get('/requirement/selection/departmentCityList', { ...params }, true);
}

/**
 * 商业等级列表
 * https://yapi.lanhanba.com/project/307/interface/api/34228
 */
export function getBusinessLevel(params?: any) {
  return get('/recommend/selection/businessList', { ...params }, true);
}

/**
 * 存储列表自定义列表字段
 * https://yapi.lanhanba.com/project/378/interface/api/45079
 */
export function postConfigCustomField(params = {}) {
  return post('/account/config/customField', params, {
    needHint: true,
    proxyApi: '/mirage',
    needCancel: false
  });
};

/**
 * 获取列表自定义列表字段
 * https://yapi.lanhanba.com/project/378/interface/api/46017
 */
export function getConfigCustomField(params = {}) {
  return get('/account/config/findCustomField', params, {
    needHint: true,
    proxyApi: '/mirage',
    needCancel: false
  });
};


/**
 * 行政区域
 * http://yapi.lanhanba.com/project/289/interface/api/33054
 */
export function areaList(params?: any) {
  return get('/area/list', { ...params }, {
    proxyApi: '/mirage',
    needHint: true,
    needCancel: false,
  });
}


/**
 * 带enname的城市列表
 * https://yapi.lanhanba.com/project/378/interface/api/35468
 */
export function getCityList(params?: any) {
  return get(
    '/area/cityList',
    { ...params },
    {
      proxyApi: '/mirage',
      needHint: true,
      needCancel: false,
    },
  );
}


/**
 * 获取七牛 token
 *
 */
export function getQiniuToken(params: any) {
  return get('/qiniu/token', { ...params }, { needHint: true, needCancel: false });
}

/**
 * 城市列表（带经纬度）
 * https://yapi.lanhanba.com/project/307/interface/api/76180
 */
export function getCityListWithLngLat(params?: any) {
  return get('/requirement/cityList', { ...params }, { isMock: true, needHint: true, needCancel: false, });
}

/**
 * oss上传 预签名
 * https://yapi.lanhanba.com/project/297/interface/api/90253
 */
export function signFile(params?: any) {
  return post(`/oss/preSign`, params, {
    proxyApi: '/terra',
    needHint: true,
  });
}

